import { SupportedTokens } from '@sovryn/contracts';
export const BORROW_ASSETS = [SupportedTokens.dllr, SupportedTokens.zusd];
